import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { DriverDetails as DriverProps } from '../../../API/types/Drivers';
import { generatePreviewFullName } from '../../../pages/Drivers/Modals/helpers';
import { ThemeType } from '../../../theme/themeType';
import { generateScoreColor, getScoreLabel, hasDisplayableEntityScore } from '../../../utils/commonUtils';
import { IconKeys } from '../../common/Icon/IconKeys';
import Tags from '../../common/Tags';
import S from './AddDriverToVehicleStyles';
import useDriverThumbnail from '../../../theme/useDriverThumbnail';
import { Button } from '../../ui/Button/Button';
import Icon from '../../common/Icon/Icon';

type Props = {
  driver: DriverProps;
  isChecked: boolean;
  selectDriver: (driver: DriverProps) => void;
};

function Driver({
  driver, isChecked, selectDriver,
}: Props): JSX.Element {
  const {
    _id: driverId,
    distanceInKmTotal,
    firstName,
    lastName,
    avatarUrl,
    licenseName,
    score,
  } = driver;

  const navigate = useNavigate();
  const theme = useTheme() as ThemeType;
  const driverThumbnail = useDriverThumbnail();

  const handleGoToDriver = (): void => {
    navigate(`/drivers/${driverId}`);
  };

  return (
    <S.DriverWrapper
      onClick={() => selectDriver(driver)}
    >
      <input type="radio" name="sort-by" id={driverId} checked={isChecked} disabled />
      <label htmlFor={driverId}>
        {hasDisplayableEntityScore(score, distanceInKmTotal) && (
          <Tags.Status label={getScoreLabel(score)} backgroundColor={generateScoreColor(score)} />
        )}
        {!hasDisplayableEntityScore(score, distanceInKmTotal) && (
          <Tags.Status label="No score" backgroundColor={theme.colors.outline} title="This vehicle didn't have any trips yet." />
        )}
        <span className="checkbox" />
      </label>
      <Tags.ItemOverview
        avatar={avatarUrl || driverThumbnail}
        avatarAlt="driver"
        title={generatePreviewFullName(firstName, lastName)}
        subtitle={licenseName as string}
      />
      <div className="tags-container no-face">
        {!driver.faceData && (
          <Tags.LabeledIcon
            label="No face data"
            icon={IconKeys.USER}
          />
        )}
      </div>
      <div className="buttons-container">
        <Button
          height="44px"
          padding="10px 12px"
          title="Go to driver"
          onClick={handleGoToDriver}
        >
          <Icon iconKey={IconKeys.USER} />
        </Button>
      </div>
    </S.DriverWrapper>
  );
}

export default Driver;
